"use client";

import { cn, Icon, Typography } from "@kyan/ui";

import { type Theme } from "#/config/theme";
import { useTheme } from "#/hooks/useTheme";

interface ThemeSwitcherProps {
  showLabel?: boolean;
}

export const ThemeSwitcher: React.FC<ThemeSwitcherProps> = ({
  showLabel = true,
}) => {
  const {
    isDark,
    theme: currentTheme,
    themes,
    setTheme,
    handleToggleTheme,
  } = useTheme();

  return (
    <div className="flex flex-col justify-between gap-4 sm:flex-row">
      {showLabel && (
        <button
          className="grid cursor-pointer justify-items-start gap-1.5"
          onClick={handleToggleTheme}
        >
          <Typography primary>Platform Color Mode</Typography>
          <Typography className="sm:mr-14">
            Select your preferred display style for the platform.
          </Typography>
        </button>
      )}

      <div className="border-divider flex gap-1 rounded-full border p-2">
        {Object.entries(themes).map(([theme, { icon, label }]) => (
          <button
            key={label}
            className={cn(
              "flex flex-1 cursor-pointer items-center justify-center gap-2 rounded-full px-4 py-2 transition-colors",
              {
                "hover:text-primary": theme !== currentTheme,
                "bg-primary text-textPrimary": theme === "dark" && isDark,
                "text-primary bg-white shadow-[0_2px_14px_0_rgba(201,201,201,0.50)]":
                  theme === "light" && !isDark,
              },
            )}
            onClick={() => {
              setTheme(theme as Theme);
            }}
          >
            <Icon size="sm" name={icon} />
            <Typography className="whitespace-nowrap">{label}</Typography>
          </button>
        ))}
      </div>
    </div>
  );
};
